exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host > .map-container {\n  position: relative;\n  overflow: hidden;\n  z-index: 2;\n  width: calc(100% - 20px);\n  height: calc(100vh - 100px - 50px - 1px);\n  margin-top: 100px; }\n  :host > .map-container geomap .top-left, :host > .map-container geomap .top-right {\n    padding: 10px; }\n  :host > .map-container .loading-overlay {\n    background-color: rgba(128, 128, 128, 0.65);\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    width: 100%;\n    height: 100%;\n    z-index: 1200; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/SPA/src/app/client/serviceObject/map/service-object-map.component.scss
// module id = ../../../../../src/app/client/serviceObject/map/service-object-map.component.scss
// module chunks = 0